import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Sidebar = () => {
  const [popularPosts, setPopularPosts] = useState([]);
  const [price, setPrice] = useState(null);

  useEffect(() => {
    const fetchPopular = async () => {
      try {
        const response = await axios.get(`${API}/articles/popular/top?limit=5`);
        setPopularPosts(response.data);
      } catch (error) {
        console.error('Error fetching popular posts:', error);
      }
    };

    const fetchPrice = async () => {
      try {
        const response = await axios.get(`${API}/bitcoin/price`);
        setPrice(response.data.bitcoin);
      } catch (error) {
        console.error('Error fetching price:', error);
      }
    };

    fetchPopular();
    fetchPrice();
  }, []);

  return (
    <aside className="space-y-6" data-testid="sidebar">
      {price && (
        <div className="bg-card border border-border rounded-sm p-6 text-card-foreground">
          <h3 className="text-lg font-bold mb-4 flex items-center gap-2 text-card-foreground">
            <TrendingUp className="text-primary" size={20} />
            Preço do Bitcoin
          </h3>
          <div className="space-y-2">
            <div>
              <div className="text-sm text-muted-foreground">USD</div>
              <div className="text-2xl font-mono font-bold text-card-foreground">${price.usd?.toLocaleString()}</div>
            </div>
            <div>
              <div className="text-sm text-muted-foreground">BRL</div>
              <div className="text-2xl font-mono font-bold text-card-foreground">R$ {price.brl?.toLocaleString()}</div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-card border border-border rounded-sm p-6 text-card-foreground">
        <h3 className="text-lg font-bold mb-4 text-card-foreground">Posts Populares</h3>
        <div className="space-y-4">
          {popularPosts.map((post) => (
            <Link
              key={post.id}
              to={`/${post.category === 'news' ? 'noticias' : post.category === 'tutorial' ? 'tutoriais' : 'artigos'}/${post.slug}`}
              className="block group"
            >
              <h4 className="text-sm font-semibold text-card-foreground group-hover:text-primary transition-colors line-clamp-2">
                {post.title}
              </h4>
              <div className="text-xs text-muted-foreground mt-1">
                {post.views} visualizações
              </div>
            </Link>
          ))}
          {popularPosts.length === 0 && (
            <p className="text-sm text-muted-foreground">Sem posts populares ainda.</p>
          )}
        </div>
      </div>

      <div className="bg-muted border border-border rounded-sm p-6 text-center">
        <div className="text-xs text-muted-foreground mb-2">ANÚNCIO</div>
        <div className="aspect-square bg-background rounded-sm flex items-center justify-center">
          <span className="text-muted-foreground">Espaço Publicitário</span>
        </div>
      </div>
    </aside>
  );
};
